export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href =
    'https://docs.microsoft.com/en-us/azure/active-directory/conditional-access/block-legacy-authentication';
